import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { PageShellComponent } from '@shared/components/page-shell/page-shell.component';

interface ContentSection {
  titleKey: string;
  bodyKey: string;
}

interface AccessCategory {
  titleKey: string;
  descriptionKey: string;
}

@Component({
  selector: 'app-arp-page',
  standalone: true,
  imports: [TranslocoPipe, PageShellComponent],
  templateUrl: './arp.page.html',
})
export class ArpPage {
  protected readonly arpUrl = 'https://arp.enap.gov.br';
  protected readonly dataDictionaryHref =
    'mailto:dados@enap.gov.br?subject=Dicion%C3%A1rio%20de%20Dados%20ARP';

  protected readonly breadcrumb = [{ labelKey: 'nav.remoteResearchEnvironment' }];

  protected readonly sections: ContentSection[] = [
    {
      titleKey: 'pages.arp.sections.what.title',
      bodyKey: 'pages.arp.sections.what.body',
    },
    {
      titleKey: 'pages.arp.sections.goal.title',
      bodyKey: 'pages.arp.sections.goal.body',
    },
    {
      titleKey: 'pages.arp.sections.collection.title',
      bodyKey: 'pages.arp.sections.collection.body',
    },
  ];

  protected readonly accessCategories: AccessCategory[] = [
    {
      titleKey: 'pages.arp.access.categories.visiting.title',
      descriptionKey: 'pages.arp.access.categories.visiting.description',
    },
    {
      titleKey: 'pages.arp.access.categories.partner.title',
      descriptionKey: 'pages.arp.access.categories.partner.description',
    },
    {
      titleKey: 'pages.arp.access.categories.enap.title',
      descriptionKey: 'pages.arp.access.categories.enap.description',
    },
  ];
}
